// order of roles is important
export enum ROLES {
    MANAGER = 'PROJECT_MANAGER',
    PROVIDER = 'PROJECT_PROVIDER',
    REPORTER = 'PROJECT_REPORTER',
    SPECTATOR = 'PROJECT_SPECTATOR'
}

export const TEAM_ADMIN = 'ADMINISTRATORS';
export const TEAM_CAST = '__CAST';

export const TEAM_COLORS = [
    '#FFFFFF',
    '#E45B3B',
    '#00B3BB',
    '#ECEFF5',
    '#BB1F20',
    '#3b8750',
    '#3b5b87',
    '#6f3b87',
    '#c7450e',
    '#879b05'
];

export enum PROJECT_STATUS {
    IN_PROGRESS = 'IN_PROGRESS',
    ARCHIVED = 'ARCHIVED'
}
